import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { getEventsData } from "../../data/events";
import "./event.css";


const PATTERN = [
  { type: "two-col",   count: 2 },
  { type: "three-col", count: 3 },
  { type: "tall-left", count: 3 },
];

const EventGallery = () => {
  const { id } = useParams();
  const { events } = getEventsData();

  const event = useMemo(
    () => events.find((e) => String(e.id) === String(id)),
    [events, id]
  );

  if (!event) {
    return (
      <Container className="py-5 text-center">
        <h2>Event not found.</h2>
      </Container>
    );
  }

  const { title, images } = event;

  // Build blocks
  const blocks = [];
  let cursor = 0;

  while (cursor < images.length) {
    for (const step of PATTERN) {
      if (cursor >= images.length) break;
      const take = Math.min(step.count, images.length - cursor);
      blocks.push({ type: step.type, imgs: images.slice(cursor, cursor + take) });
      cursor += take;
    }
  }

  return (
    <div className="eg-page">
      {/* Header */}
      <div className="container-lg">
        <h1 className="fw-bold">Events Gallery</h1>
        <h3 className="gallery-sub py-md-3">{title}</h3>
      </div>

      {/* Gallery */}
      <Container fluid="lg" className="eg-gallery pb-4">
        {blocks.map((block, bi) => {

          /* ── Block A: 2 equal large columns ───── */
          if (block.type === "two-col") {
            return (
              <Row key={bi} className="g-2 mb-2">
                {block.imgs.map((src, idx) => (
                  <Col key={idx} xs={12} md={6}>
                    <div className="eg-card eg-large">
                      <img src={src} alt={`${title} ${bi}-${idx}`} />
                    </div>
                  </Col>
                ))}
              </Row>
            );
          }

          /* ── Block B: 3 equal medium columns ──── */
          if (block.type === "three-col") {
            return (
              <Row key={bi} className="g-2 mb-2">
                {block.imgs.map((src, idx) => (
                  <Col key={idx} xs={12} md={4}>
                    <div className="eg-card eg-medium">
                      <img src={src} alt={`${title} ${bi}-${idx}`} />
                    </div>
                  </Col>
                ))}
              </Row>
            );
          }

          /* ── Block C: tall left + 2 stacked right ── */
          if (block.type === "tall-left") {
            const [tallImg, ...rightImgs] = block.imgs;
            return (
              <React.Fragment key={bi}>
                {/* On mobile: render all 3 as full-width stacked rows */}
                {/* On desktop: tall-left + stacked-right layout */}

                {/* Mobile view — xs={12} for each image individually */}
                <Row className="g-2 mb-2 d-md-none">
                  {[tallImg, ...rightImgs].map((src, idx) => (
                    <Col key={idx} xs={12}>
                      <div className="eg-card eg-large">
                        <img src={src} alt={`${title} ${bi}-${idx}`} />
                      </div>
                    </Col>
                  ))}
                </Row>

                {/* Desktop view — original tall-left layout */}
                <Row className="g-2 mb-2 d-none d-md-flex">
                  <Col md={5}>
                    <div className="eg-card eg-tall">
                      <img src={tallImg} alt={`${title} ${bi}-tall`} />
                    </div>
                  </Col>
                  <Col md={7} className="d-flex flex-column gap-2">
                    {rightImgs.map((src, idx) => (
                      <div key={idx} className="eg-card eg-stacked">
                        <img src={src} alt={`${title} ${bi}-r${idx}`} />
                      </div>
                    ))}
                  </Col>
                </Row>
              </React.Fragment>
            );
          }

          return null;
        })}
      </Container>
    </div>
  );
};

export default EventGallery;